import { Component, OnInit } from '@angular/core';
import { I18nService } from 'src/app/core/i18n.service';

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html'
})
export class EnterpriseComponent implements OnInit {

  constructor(
    private changeLanguageService: I18nService
  ) {
  }

  ngOnInit() {
  }

}
